var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BackLink',{attrs:{"route-from":_vm.currentOrganisation && _vm.currentOrganisation.id ?
        {
          name: 'OrganisationDetail',
          params: {
            id: _vm.currentOrganisation.id
          }
        } :
        { name: 'JurisdictionsList' },"route-name":_vm.currentOrganisation && _vm.currentOrganisation.id ?
        'OrganisationDetail' :
        'JurisdictionsList',"title":_vm.currentOrganisation && _vm.currentOrganisation.display_name ?
        _vm.currentOrganisation.display_name :
        _vm.capitalizeFirstLetter(_vm.$tc('words.jurisdiction', 2))}}),_c('div',{staticClass:"container-xl"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('JuridictionMap')],1),_c('div',{staticClass:"col-4"},[(_vm.$router.currentRoute.name === 'JurisdictionDetail')?_c('JurisdictionNavigation'):_vm._e(),_c('JuridictionForm',_vm._g({},_vm.$listeners))],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('JuridictionFooter',_vm._g({attrs:{"mode":_vm.mode}},_vm.$listeners))],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }